import { render, staticRenderFns } from "./Skeletonlist.vue?vue&type=template&id=2ab4faf4&"
import script from "./Skeletonlist.vue?vue&type=script&lang=js&"
export * from "./Skeletonlist.vue?vue&type=script&lang=js&"
import style0 from "./Skeletonlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports